// extracted by mini-css-extract-plugin
export default {"link":"user-table_link__bKZqx"};